import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { useFormikContext } from 'formik';

import { CissTextField } from 'components/fields';
import {
    DreConfigEstruturaMercadologica,
    DreTipoPreenchimentoAutoComplete,
    DreTipoRegimeTributarioAutoComplete,
} from 'pages/financeiro/dre/configuracao/components';
import { useDreConfigContext } from 'pages/financeiro/dre/configuracao/contexts';
import { DreConfiguracao } from 'pages/financeiro/dre/configuracao/types';

export function DreConfigConfiguracoesModalForm() {
    const { values, setFieldValue, errors } = useFormikContext<DreConfiguracao>();
    const { activeGrupo } = useDreConfigContext();
    const isImpostos = activeGrupo?.dreMercadologicaTipoGrupoExibicaoEnum === 'IMPOSTOS';
    const isDespesas = activeGrupo?.dreMercadologicaTipoGrupoExibicaoEnum === 'DESPESAS';
    const isCustos = activeGrupo?.dreMercadologicaTipoGrupoExibicaoEnum === 'CUSTOS';
    const isVendas = activeGrupo?.dreMercadologicaTipoGrupoExibicaoEnum === 'VENDAS';

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2 }}>
                <CissTextField
                    size="small"
                    label="Descrição"
                    value={values.dsNomeExibicao}
                    error={errors.dsNomeExibicao}
                    onChange={(e) => setFieldValue('dsNomeExibicao', e.target.value)}
                />

                <CissTextField
                    size="small"
                    label="Nome da variável"
                    value={values.dsNomeVariavel}
                    error={errors.dsNomeVariavel}
                    onChange={(e) => setFieldValue('dsNomeVariavel', e.target.value)}
                />
            </Box>

            {(isDespesas || isCustos) && (
                <>
                    <DreTipoPreenchimentoAutoComplete
                        size="small"
                        sx={{ flex: 1 }}
                        value={values.dreTipoPreenchimento}
                        error={errors.dreTipoPreenchimento}
                        onChange={(e, value) => setFieldValue('dreTipoPreenchimento', value)}
                    />

                    <CissTextField
                        size="small"
                        sx={{ flex: 1 }}
                        label="Valor da configuração"
                        value={values.dsValorConfig}
                        error={errors.dsValorConfig}
                        onChange={(e) => setFieldValue('dsValorConfig', e.target.value)}
                    />
                </>
            )}

            {isImpostos && (
                <DreTipoRegimeTributarioAutoComplete
                    size="small"
                    value={values.tipoRegimeTributario}
                    error={errors.tipoRegimeTributario}
                    onChange={(e, value) => setFieldValue('tipoRegimeTributario', value)}
                />
            )}

            <CissTextField
                size="small"
                label="Observação"
                value={values.dsObservacao}
                error={errors.dsObservacao}
                onChange={(e) => setFieldValue('dsObservacao', e.target.value)}
            />

            {isVendas && <DreConfigEstruturaMercadologica />}

            {(isDespesas || isCustos) && (
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
                    <FormControlLabel
                        label="Obrigatório"
                        control={<Checkbox />}
                        checked={values.fgObrigatorio}
                        onChange={(e, value) => setFieldValue('fgObrigatorio', value)}
                    />

                    {isDespesas && (
                        <FormControlLabel
                            label="Recorrente"
                            name="fgRecorrente"
                            control={<Checkbox />}
                            checked={values.fgRecorrente}
                            onChange={(e, value) => setFieldValue('fgRecorrente', value)}
                        />
                    )}

                    {isCustos && (
                        <>
                            <FormControlLabel
                                label="Totalizar"
                                name="fgFreteGratis"
                                control={<Checkbox />}
                                checked={values.fgTotalizar}
                                onChange={(e, value) => setFieldValue('fgTotalizar', value)}
                            />

                            <FormControlLabel
                                label="Percentual"
                                control={<Checkbox />}
                                checked={values.fgPercentual}
                                onChange={(e, value) => setFieldValue('fgPercentual', value)}
                            />
                        </>
                    )}
                </Box>
            )}
        </>
    );
}
